import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/layout'
// import store from '../store/store'

Vue.use(Router)

const routers = [
    {
        path: '/',
        meta: {
            title: '作客小程序管理中心'
        },
        component: (resolve) => require(['../views/login.vue'], resolve)
    },
    {
        path: '/login',
        name: '登录',
        meta: {
            title: '登录'
        },
        component: (resolve) => require(['../views/login.vue'], resolve)
    },
    {
        path: '',
        component: Layout,
        name: '',
        children: [
            {
                path: '/index',
                component: () => import('@/views/content/index'),
                name: '首页',
                meta: { 
                    title: '首页',
                    breadcrumb: true
                }
            }
        ]
    },
    {
        path: '/',
        component: Layout,
        name: '短剧&分集管理',
        meta: {
            title: '短剧&分集管理',
            breadcrumb: true
        },
        children: [
            {
                path: '/video-manage-list',
                component: (resolve) => require(['../views/content/video/video-manage-list'], resolve),
                name: '短剧管理',
                meta: {
                    title: '添加短剧',
                    breadcrumb: true
                }
            },
            {
                path: '/video-ep-manage-list',
                component: (resolve) => require(['../views/content/video/video-ep-manage-list.vue'], resolve),
                name: '分集管理',
                meta: {
                    title: '分集管理',
                    breadcrumb: true
                }
            },
            {
                path: '/video-preview-config',
                component: (resolve) => require(['../views/content/video/video-preview-config.vue'], resolve),
                name: '短剧试看配置',
                meta: {
                    title: '短剧试看配置',
                    breadcrumb: true
                }
            },
        ]
    },
    {
        path: '/',
        component: Layout,
        name: '用户数据管理',
        meta: {
            title: '用户数据管理',
            breadcrumb: true
        },
        children: [
            {
                path: '/video-user-list',
                component: (resolve) => require(['@/views/content/user/video-user-list.vue'], resolve),
                name: '用户管理',
                meta: {
                    title: '用户管理',
                    breadcrumb: true
                }
            },
            {
                path: '/video-recharget-list',
                component: (resolve) => require(['@/views/content/user/video-recharget-list.vue'], resolve),
                name: '充值记录',
                meta: {
                    title: '充值记录',
                    breadcrumb: true
                }
            },
            {
                path: '/video-subscribe-list',
                component: (resolve) => require(['@/views/content/user/video-subscribe-list.vue'], resolve),
                name: '剧集支付&观剧记录',
                meta: {
                    title: '剧集支付&观剧记录',
                    breadcrumb: true
                }
            },
            {
                path: '/video-feedback-list',
                component: (resolve) => require(['@/views/content/user/video-feedback-list.vue'], resolve),
                name: '用户反馈记录',
                meta: {
                    title: '用户反馈记录',
                    breadcrumb: true
                }
            },
            {
                path: '/video-incomepay-list',
                component: (resolve) => require(['@/views/content/user/video-incomepay-list.vue'], resolve),
                name: '金币收支记录',
                meta: {
                    title: '金币收支记录',
                    breadcrumb: true
                }
            }
        ]
    },
    {
        path: '/',
        component: Layout,
        name: '小程序配置',
        meta: {
            title: '小程序配置',
            breadcrumb: true
        },
        children: [
            {
                path: '/micro-app-config',
                component: (resolve) => require(['@/views/content/app/micro-app-config.vue'], resolve),
                name: '小程序管理',
                meta: {
                    title: '小程序管理',
                    breadcrumb: true
                }
            },
            {
                path: '/video-group-config',
                component: (resolve) => require(['@/views/content/app/video-group-config.vue'], resolve),
                name: '剧场配置',
                meta: {
                    title: '剧场配置',
                    breadcrumb: true
                }
            },
            {
                path: '/binge-watching-config',
                component: (resolve) => require(['@/views/content/app/binge-watching-config.vue'], resolve),
                name: '追剧配置',
                meta: {
                    title: '追剧配置',
                    breadcrumb: true
                }
            },
            {
                path: '/recharge-config',
                component: (resolve) => require(['@/views/content/app/recharge-config.vue'], resolve),
                name: '充值配置',
                meta: {
                    title: '充值配置',
                    breadcrumb: true,
                }
            },
            {
                path: '/ad-unlock-config',
                component: (resolve) => require(['@/views/content/app/ad-unlock-config.vue'], resolve),
                name: '广告解锁配置',
                meta: {
                    title: '广告解锁配置',
                    breadcrumb: true
                }
            },
            {
                path: '/return-event-depth-config',
                component: (resolve) => require(['@/views/content/app/return-event-depth-config.vue'], resolve),
                name: '回传事件深度配置',
                meta: {
                    title: '回传事件深度配置',
                    breadcrumb: true
                }
            },
            {
                path: '/welfare-task-config',
                component: (resolve) => require(['@/views/content/app/welfare-task-config.vue'], resolve),
                name: '福利任务配置',
                meta: {
                    title: '福利任务配置',
                    breadcrumb: true
                }
            },
            {
                path: '/subscribe-message-manage',
                component: (resolve) => require(['@/views/content/app/subscribe-message-manage.vue'], resolve),
                name: '订阅消息管理',
                meta: {
                    title: '订阅消息管理',
                    breadcrumb: true
                }
            },
            {
                path: '/exit-playback-recom-video',
                component: (resolve) => require(['@/views/content/app/exit-playback-recom-video.vue'], resolve),
                name: '播放页退出推荐剧配置',
                meta: {
                    title: '播放页退出推荐剧配置',
                    breadcrumb: true
                }
            },
        ]
    },
    {
        path: '/',
        component: Layout,
        name: '代理商管理',
        meta: {
            title: '代理商管理',
            breadcrumb: true
        },
        children: [
            {
                path: '/agent-account',
                component: (resolve) => require(['@/views/content/agentManage/agent-account.vue'], resolve),
                name: '代理商账户',
                meta: {
                    title: '代理商账户',
                    breadcrumb: true
                }
            }
        ]
    },
    {
        path: '/',
        component: Layout,
        name: '代理商菜单',
        meta: {
            title: '代理商菜单',
            breadcrumb: true
        },
        children: [
            {
                path: '/agent-ad-unlock-config',
                component: (resolve) => require(['@/views/content/agentMenu/agent-ad-unlock-config.vue'], resolve),
                name: '广告解锁配置',
                meta: {
                    title: '广告解锁配置',
                    breadcrumb: true
                }
            },
            {
                path: '/return-config',
                component: (resolve) => require(['@/views/content/agentMenu/return-config.vue'], resolve),
                name: '回传配置',
                meta: {
                    title: '回传配置',
                    breadcrumb: true
                }
            },
            {
                path: '/pro-link-list',
                component: (resolve) => require(['@/views/content/agentMenu/pro-link-list.vue'], resolve),
                name: '投放链接',
                meta: {
                    title: '投放链接',
                    breadcrumb: true
                }
            },
            {
                path: '/agent-recharge-config',
                component: (resolve) => require(['@/views/content/agentMenu/agent-recharge-config.vue'], resolve),
                name: '代理商-充值配置',
                meta: {
                    title: '代理商-充值配置',
                    breadcrumb: true
                },
            }
        ]
    },
    {
        path: '/',
        component: Layout,
        name: '数据统计',
        meta: {
            title: '数据统计',
            breadcrumb: true
        },
        children: [
            {
                path: '/video-daily-data-list',
                component: (resolve) => require(['@/views/content/data/video-daily-data-list.vue'], resolve),
                name: '剧每日数据',
                meta: {
                    title: '剧每日数据',
                    breadcrumb: true
                }
            },
            {
                path: '/account-stat-data-list',
                component: (resolve) => require(['@/views/content/data/account-stat-data-list.vue'], resolve),
                name: '账户数据统计',
                meta: {
                    title: '账户数据统计',
                    breadcrumb: true
                }
            },
            {
                path: '/pro-link-stat-data-list',
                component: (resolve) => require(['@/views/content/data/pro-link-stat-data-list.vue'], resolve),
                name: '推广链接统计',
                meta: {
                    title: '推广链接统计',
                    breadcrumb: true
                }
            },
            {
                path: '/ad-add-miss-return-list',
                component: (resolve) => require(['@/views/content/data/ad-add-miss-return-list.vue'], resolve),
                name: '广告补回传',
                meta: {
                    title: '广告补回传',
                    breadcrumb: true
                }
            }
        ]
    },
    {
        path: '/',
        component: Layout,
        name: '抖音媒资管理',
        meta: {
            title: '抖音媒资管理',
            breadcrumb: true
        },
        children: [
            {
                path: '/media-add-video-list',
                component: (resolve) => require(['@/views/content/dymedia/media-add-video-list.vue'], resolve),
                name: '添加短剧',
                meta: {
                    title: '添加短剧',
                    breadcrumb: true
                }
            },
            {
                path: '/media-add-ep-list',
                component: (resolve) => require(['@/views/content/dymedia/media-add-ep-list.vue'], resolve),
                name: '分集管理',
                meta: {
                    title: '分集管理',
                    breadcrumb: true
                }
            },
            {
                path: '/media-binding-list',
                component: (resolve) => require(['@/views/content/dymedia/media-binding-list.vue'], resolve),
                name: '页面绑定',
                meta: {
                    title: '页面绑定',
                    breadcrumb: true
                }
            },
        ]
    },
    {
        path: '/',
        component: Layout,
        name: '分销管理',
        meta: {
            title: '分销管理',
            breadcrumb: true
        },
        children: [
            {
                path: '/platform-income-list',
                component: (resolve) => require(['@/views/content/platform/platform-income-list.vue'], resolve),
                name: '结算中心',
                meta: {
                    title: '结算中心',
                    breadcrumb: true
                }
            },
            {
                path: '/platform-cashed-list',
                component: (resolve) => require(['@/views/content/platform/platform-cashed-list.vue'], resolve),
                name: '提现管理',
                meta: {
                    title: '提现管理',
                    breadcrumb: true
                }
            }
        ]
    },
    {
        path: '/',
        component: Layout,
        name: '权限设置',
        meta: {
            title: '权限设置',
            breadcrumb: true
        },
        children: [
            {
                path: '/sys-user-manage',
                component: (resolve) => require(['../views/content/system/user-manage.vue'], resolve),
                name: '账户管理',
                meta: {
                    title: '账户管理',
                    breadcrumb: true
                }
            },
            {
                path: '/sys-roles-manage',
                component: (resolve) => require(['../views/content/system/role-manage.vue'], resolve),
                name: '角色管理',
                meta: {
                    title: '角色管理',
                    breadcrumb: true
                }
            },
            {
                path: '/sys-department-manage',
                component: (resolve) => require(['../views/content/system/department-manage.vue'], resolve),
                name: '部门管理',
                meta: {
                    title: '部门管理',
                    breadcrumb: true
                }
            },
            {
                path: '/role-permission',
                component: (resolve) => require(['../views/content/system/role-permission.vue'], resolve),
                leafInfo: true,
                name: '权限管理',
                meta: {
                    title: '权限管理',
                    breadcrumb: true
                }
            }
        ]
    },
    // 微博短剧 -----------------------------------------------------------
    {
        path: '/',
        component: Layout,
        name: '小程序管理',
        meta: {
            title: '小程序管理',
            breadcrumb: true
        },
        children: [
            {
                path: '/wbsv-recharge',
                component: (resolve) => require(['../views/wbsv/app/wbdp-recharge-config.vue'], resolve),
                name: '充值配置',
                meta: {
                    title: '充值配置',
                    breadcrumb: true
                }
            }
        ]
    },
    {
        path: '/',
        component: Layout,
        name: '投放管理',
        meta: {
            title: '投放管理',
            breadcrumb: true
        },
        children: [
            {
                path: '/wbsv-return',
                component: (resolve) => require(['../views/wbsv/proManage/wbsv-return.vue'], resolve),
                name: '回传配置',
                meta: {
                    title: '回传配置',
                    breadcrumb: true
                }
            },
            {
                path: '/wbsv-returnlink',
                component: (resolve) => require(['../views/wbsv/proManage/wbsv-returnlink.vue'], resolve),
                name: '投放链接',
                meta: {
                    title: '投放链接',
                    breadcrumb: true
                }
            },
        ]
    },
    {
        path: '/',
        component: Layout,
        name: '数据统计',
        meta: {
            title: '数据统计',
            breadcrumb: true
        },
        children: [
            {
                path: '/wbsv-returnorder',
                component: (resolve) => require(['../views/wbsv/data/wbsv-returnorder.vue'], resolve),
                name: '付费补回传',
                meta: {
                    title: '付费补回传',
                    breadcrumb: true
                }
            }
        ]
    },
    // 微博短篇 -----------------------------------------------------------
    {
        path: '/',
        component: Layout,
        name: '小程序管理',
        meta: {
            title: '小程序管理',
            breadcrumb: true
        },
        children: [
            {
                path: '/wbdp-recharge-config',
                component: (resolve) => require(['../views/wb/app/wbdp-recharge-config.vue'], resolve),
                name: '充值配置',
                meta: {
                    title: '充值配置',
                    breadcrumb: true
                }
            },
            {
                path: '/wb-return-config',
                component: (resolve) => require(['@/views/wb/app/wb-return-config.vue'], resolve),
                name: '回传配置',
                meta: {
                    title: '回传配置',
                    breadcrumb: true
                }
            },
            {
                path: '/wbdp-group-config',
                component: (resolve) => require(['@/views/wb/app/wbdp-group-config.vue'], resolve),
                name: '首页组件管理',
                meta: {
                    title: '首页组件管理',
                    breadcrumb: true
                }
            },
            {
                path: '/novel-ad-unlock-config',
                    component: (resolve) => require(['@/views/dydp/app/novel-ad-unlock-config.vue'], resolve),
                name: '小说广告解锁配置',
                meta: {
                    title: '小说广告解锁配置',
                    breadcrumb: true
                }
            },
            {
                path: '/wbdp-feedback',
                component: (resolve) => require(['@/views/wb/app/wbdp-feedback.vue'], resolve),
                name: '投诉管理',
                meta: {
                    title: '投诉管理',
                    breadcrumb: true
                }
            }
        ]
    },
    {
        path: '/',
            component: Layout,
        name: '抖音内容库管理',
        meta: {
        title: '抖音内容库管理',
            breadcrumb: true
        },
            children: [
                {
                    path: '/dydp_manage_media',
                    component: (resolve) => require(['@/views/dydp/media/dydp_manage_media.vue'], resolve),
                    name: '媒资管理',
                    meta: {
                    title: '媒资管理',
                        breadcrumb: true
                    }
                },
                {
                    path: '/dydp_manage_novel',
                        component: (resolve) => require(['@/views/dydp/media/dydp_manage_novel'], resolve),
                    name: '添加小说',
                    meta: {
                    title: '添加小说',
                        breadcrumb: true
                    }
                },
                {
                    path: '/wb-subscribe-management',
                        component: (resolve) => require(['@/views/wb/user/wb-subscribe-management.vue'], resolve),
                    name: '订阅管理',
                    meta: {
                    title: '订阅管理',
                        breadcrumb: true
                    }
                }
        ]
    },
    {
        path: '/',
        component: Layout,
        name: '用户数据管理',
        meta: {
            title: '用户数据管理',
            breadcrumb: true
        },
        children: [
            {
                path: '/wbdp-user-list',
                component: (resolve) => require(['@/views/wb/user/wbdp-user-list.vue'], resolve),
                name: '用户管理',
                meta: {
                    title: '用户管理',
                    breadcrumb: true
                }
            },
            {
                path: '/wbdp-recharget-list',
                component: (resolve) => require(['@/views/wb/user/wbdp-recharget-list.vue'], resolve),
                name: '充值记录',
                meta: {
                    title: '充值记录',
                    breadcrumb: true
                }
            },
            {
                path: '/wb-subscribe-management',
                component: (resolve) => require(['@/views/wb/user/wb-subscribe-management.vue'], resolve),
                name: '订阅管理',
                meta: {
                    title: '订阅管理',
                    breadcrumb: true
                }
            }
        ]
    },
    {
        path: '/',
        component: Layout,
        name: '代理商菜单',
        meta: {
            title: '代理商菜单',
            breadcrumb: true
        },
        children: [
            {
                path: '/wb-agent-return-config',
                component: (resolve) => require(['@/views/wb/agentMenu/wb-agent-return-config.vue'], resolve),
                name: '回传配置',
                meta: {
                    title: '回传配置',
                    breadcrumb: true
                }
            },
            {
                path: '/novel-agent-ad-unlock-config',
                    component: (resolve) => require(['@/views/dydp/agentMenu/novel-agent-ad-unlock-config.vue'], resolve),
                name: '小说广告解锁配置',
                meta: {
                    title: '小说广告解锁配置',
                    breadcrumb: true
                }
            },
            {
                path: '/wbdp-pro-link-list',
                component: (resolve) => require(['@/views/wb/agentMenu/wbdp-pro-link-list.vue'], resolve),
                name: '投放链接',
                meta: {
                    title: '投放链接',
                    breadcrumb: true
                }
            },
            {
                path: '/wbdp-agent-recharge-config',
                component: (resolve) => require(['@/views/wb/agentMenu/wbdp-agent-recharge-config.vue'], resolve),
                name: '代理商-充值配置',
                meta: {
                    title: '代理商-充值配置',
                    breadcrumb: true
                },
            },
            {
                path: '/wx-agent-return-config',
                component: (resolve) => require(['@/views/wb/agentMenu/wx-agent-return-config'], resolve),
                name: '微信回传配置',
                meta: {
                    title: '微信回传配置',
                    breadcrumb: true
                },
            },
            {
                path: '/dydp-pro-link-list',
                    component: (resolve) => require(['@/views/dydp/agentMenu/dydp-pro-link-list.vue'], resolve),
                name: '抖音投放链接',
                meta: {
                    title: '抖音投放链接',
                    breadcrumb: true
                }
            }
        ]
    },
    {
        path: '/',
        component: Layout,
        name: '数据统计',
        meta: {
            title: '数据统计',
            breadcrumb: true
        },
        children: [
            {
                path: '/wbdp-ad-add-miss-return-list',
                component: (resolve) => require(['../views/wb/data/wbdp-ad-add-miss-return-list.vue'], resolve),
                name: '付费补回传',
                meta: {
                    title: '付费补回传',
                    breadcrumb: true
                }
            },
            {
                path: '/wbdp-ad-user-list',
                component: (resolve) => require(['../views/wb/data/wbdp-ad-user-list.vue'], resolve),
                name: '用户信息',
                meta: {
                    title: '用户信息',
                    breadcrumb: true
                }
            },
            {
                path: '/wbdp-accountStatistics-list',
                component: (resolve) => require(['../views/wb/data/wbdp-accountStatistics-list.vue'], resolve),
                name: '账户数据统计',
                meta: {
                    title: '账户数据统计',
                    breadcrumb: true
                }
            },
            {
                path: '/wbdp-promotionLink-list',
                component: (resolve) => require(['../views/wb/data/wbdp-promotionLink-list.vue'], resolve),
                name: '推广链接统计',
                meta: {
                    title: '推广链接统计',
                    breadcrumb: true
                }
            },
            {
                path: '/dydp-accountStatistics-list',
                component: (resolve) => require(['../views/dydp/data/dydp-accountStatistics-list.vue'], resolve),
                name: '抖音账户数据统计',
                meta: {
                    title: '抖音账户数据统计',
                    breadcrumb: true
                }
            },
            {
                path: '/dydp-promotionLink-list',
                component: (resolve) => require(['../views/dydp/data/dydp-promotionLink-list.vue'], resolve),
                name: '抖音推广链接统计',
                meta: {
                    title: '抖音推广链接统计',
                    breadcrumb: true
                }
            },
            {
                path: '/wbdp-dailyData-list',
                component: (resolve) => require(['../views/wb/data/wbdp-dailyData-list.vue'], resolve),
                name: '书每日数据',
                meta: {
                    title: '书每日数据',
                    breadcrumb: true
                }
            },
            {
                path: '/wbdp-long-tail',
                component: (resolve) => require(['../views/wb/data/wbdp-long-tail.vue'], resolve),
                name: '微博小程序长尾统计',
                meta: {
                    title: '微博小程序长尾统计',
                    breadcrumb: true
                }
            }
        ]
    },
    // 微信短剧 -----------------------------------------------------------
    {
        path: '/',
        component: Layout,
        name: '微信媒资管理',
        meta: {
            title: '添加短剧',
            breadcrumb: true
        },
        children: [
            {
                path: '/media-add-video-listwx',
                component: (resolve) => require(['../views/wxsvzk/media/media-add-video-listwx'], resolve),
                name: '添加短剧',
                meta: {
                    title: '添加短剧',
                    breadcrumb: true
                }
            },
        ]
    },
    {
        path: '/wx-landing-page',
        component: (resolve) => require(['../views/wx-landing-page'], resolve),
        name: '短剧落地页',
        meta: {
            title: '短剧落地页',
            breadcrumb: true
        },
        children: []
    }
]

// 路由配置
const RouterConfig = {
    mode: 'history',
    routes: routers
}
const router = new Router(RouterConfig)
router.beforeEach((to, from, next) => {
    // let isLogin = store.state.home.isLogin.value
    if (to.meta.title) {
        document.title = to.meta.title
    }
    next()
})

router.afterEach(() => {
    window.scrollTo(0, 0)
})
export default router
